"use client";

import { useCallback } from "react";

export function SkipLink() {
  const handleClick = useCallback((e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const mainContent = document.getElementById("main-content");
    if (mainContent) {
      mainContent.focus({ preventScroll: false });
      mainContent.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, []);

  return (
    <a
      href="#main-content"
      onClick={handleClick}
      className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[9999] focus:px-4 focus:py-3 focus:bg-white focus:text-black focus:font-semibold focus:rounded-lg focus:border focus:border-black focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2 focus:no-underline"
    >
      Skip to main content
    </a>
  );
}
